import { Cast, CastType, IDataModel, Model } from '@klickdata/core/application';
import { AppScope } from '@klickdata/core/resource';
import { SectionData } from '@klickdata/core/section';
import { Filter } from '@klickdata/core/table';
export enum CustomTabPrivacy {
    PUBLIC = 'public',
    PRIVATE = 'private',
    ACADEMY = 'academy',
    ACADEMY_REQUIRED = 'academy_required',
}
export interface CustomTabData extends IDataModel {
    id?: number;
    name?: any;
    key?: string;
    scope_id?: AppScope;
    customer_id?: number;
    order?: number;
    enabled?: boolean;
    disabled?: boolean;
    editable?: boolean;
    disableActiveSwitch?: boolean;
    canBeDeleted?: boolean;
    filters?: { [key: string]: any }[];
    eager?: string[];
    metadata?: {
        order?: number;
        filters?: Filter<string | number>[];
        disabled?: boolean;
        name?: any;
    };
    available_scopes?: AppScope[];
    available_sections?: SectionData[];
    privacy?: CustomTabPrivacy;
    badge?: number;
}

export class CustomTab extends Model<CustomTabData> {
    id: number;
    name: any;
    key?: string;
    scope_id?: AppScope;
    customer_id?: number;
    @Cast(CastType.CLOSURE, (order: string | number) => +order)
    order: number;
    enabled?: boolean;
    disabled?: boolean;
    disableActiveSwitch?: boolean;
    canBeDeleted?: boolean;
    editable?: boolean;
    filters?: { [key: string]: any }[];
    eager?: string[];
    metadata?: {
        order?: number;
        filters?: { property: string; items: any }[];
        disabled?: boolean;
        name?: any;
    };
    badge?: number;
    available_scopes?: AppScope[];
    available_sections?: SectionData[];
    privacy?: CustomTabPrivacy;
}
